import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { LanguageProvider } from './context/LanguageContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { WishlistProvider } from './context/WishlistContext';
import { AdminAuthProvider } from './admin/context/AdminAuthContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products'; // Müştəri üçün olan vitrin
import Features from './components/Features';
import Footer from './components/Footer';
import CartSidebar from './components/CartSidebar';
import InstallPrompt from './components/InstallPrompt';
import Delivery from './pages/Delivery';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import Wishlist from './pages/Wishlist';
import './App.css';
import './pwa/registerSW'; // PWA: service worker qeydiyyatı (yalnız production)

// Admin Səhifələri
import AdminLogin from './admin/pages/AdminLogin';
import AdminLayout from './admin/components/AdminLayout';
import Dashboard from './admin/pages/Dashboard';
// Admin üçün olan Məhsul İdarəetmə Paneli (Ad toqquşmaması üçün AdminProducts olaraq import etdik)
import AdminProducts from './admin/pages/Products';
import AdminOrders from './admin/pages/Orders';
import AdminAnalytics from './admin/pages/Analytics';

// Səhifədaxili ID-ləri (#products, #about) tutub ekranı aşağı sürüşdürmək üçün komponent
const ScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
};

const HomePage = () => (
  <>
    <Hero />
    <div id="about">
      <About />
    </div>
    <Products />
    <Features />
  </>
);

const PublicLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
    <CartSidebar />
    <InstallPrompt />
  </>
);

function App() {
  return (
    <LanguageProvider>
      <CurrencyProvider>
        <WishlistProvider>
          <CartProvider>
            <AdminAuthProvider>
              <BrowserRouter>
                <ScrollToHash />
                <div className="App">
                  <Routes>
                    {/* Public Routes */}
                    <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
                    <Route path="/catdirilma" element={<PublicLayout><Delivery /></PublicLayout>} />
                    <Route path="/elaqe" element={<PublicLayout><Contact /></PublicLayout>} />
                    <Route path="/blog" element={<PublicLayout><Blog /></PublicLayout>} />
                    <Route path="/blog/:slug" element={<PublicLayout><Blog /></PublicLayout>} />
                    <Route path="/wishlist" element={<PublicLayout><Wishlist /></PublicLayout>} />

                    {/* Admin Routes */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminLayout />}>
                      <Route index element={<Navigate to="/admin/dashboard" replace />} />
                      <Route path="dashboard" element={<Dashboard />} />
                      <Route path="products" element={<AdminProducts />} />
                      <Route path="orders" element={<AdminOrders />} />
                      <Route path="analytics" element={<AdminAnalytics />} />
                    </Route>
                  </Routes>
                </div>
              </BrowserRouter>
            </AdminAuthProvider>
          </CartProvider>
        </WishlistProvider>
      </CurrencyProvider>
    </LanguageProvider>
  );
}

export default App;
